import script from "./sharingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./sharingPage.vue?vue&type=script&setup=true&lang=js"

import "./sharingPage.vue?vue&type=style&index=0&id=2959d47e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2959d47e"]])

export default __exports__